const isMissingRequiredSelection = (selectedFacets, treeLevelVariants, facetConfig, currentNode)=>{
    return Boolean((facetConfig === null || facetConfig === void 0 ? void 0 : facetConfig.requiresUserSelection) && (!(currentNode === null || currentNode === void 0 ? void 0 : currentNode.facetKey) || !selectedFacets.includes(currentNode === null || currentNode === void 0 ? void 0 : currentNode.facetKey)) && treeLevelVariants.length > 1);
};

export { isMissingRequiredSelection };
//# sourceMappingURL=is-missing-required-selection.js.map
